import { render, staticRenderFns } from "./CommunityQna.vue?vue&type=template&id=497b58c5&scoped=true"
import script from "./CommunityQna.vue?vue&type=script&lang=js"
export * from "./CommunityQna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b58c5",
  null
  
)

export default component.exports